import type {ReactElement, ReactNode} from 'react';
import React, {useState} from 'react';
import {logClientError} from '@Libraries/log.library';
import {ErrorBoundary as ReactErrorBoundary} from 'react-error-boundary';

interface AddItemBarErrorBoundaryProps {
  children: ReactNode;
  fallback: ReactElement<unknown, typeof React.Component>;
}

export function AddItemBarErrorBoundary({...props}: AddItemBarErrorBoundaryProps): ReactElement<any> {
  const [reload] = useState(false);

  const onError = (e: Error): void => {
    void logClientError(e, {
      reason: 'Poster Left add item bar Error Boundary',
    });
  };

  const getFallbackUI = (): ReactElement<unknown, typeof React.Component> => {
    return props.fallback;
  };

  return (
    <ReactErrorBoundary resetKeys={[reload]} fallback={getFallbackUI()} onError={onError}>
      {props.children}
    </ReactErrorBoundary>
  );
}
